import * as React from 'react'

import isEmpty from 'lodash/isEmpty'

import { observer } from 'mobx-react'

import type { ImportedEmployee } from 'modules/employees/lib/ImportedEmployee'

import CellContent from '../CellContent'

interface Props {
  employee: ImportedEmployee
  attribute: string
}

const BasicCellContent = ({ employee, attribute }: Props) => {
  const errored = employee.status === 'errored'
  const ready = employee.status === 'ready'
  const conflicted = employee.status === 'conflicts'
  const value = employee[attribute]

  const messageContainer = errored || conflicted ? employee.errors : employee.warnings

  const message = messageContainer ? messageContainer[attribute] : ''
  const empty = isEmpty(messageContainer)
  const ok = empty || ready || !message

  return <CellContent value={value} message={message} errored={errored} ok={ok} />
}

export default observer(BasicCellContent)
